// ScrollToTop.js
import React, { useState, useEffect } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward"; // Import icon from MUI
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import CloseIcon from "@mui/icons-material/Close";
import Badge from "@mui/material/Badge"; // Import Badge from MUI
import "./FilterBox.css"; // CSS file for custom styling
import FilterListIcon from "@mui/icons-material/FilterList";
import { Box, Button, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import { TITLES, UI_TEXT } from "../../constants";
import { useTranslation } from "react-i18next";

const FilterBox = ({ additionalFilters, setAdditionalFilters }) => {
	const [isVisible, setIsVisible] = useState(false);
	const {t} = useTranslation();

	const filterBox = () => {
		console.log("filterBox", additionalFilters);
		setIsVisible(!isVisible);
	};

	return (
		<>
			{isVisible && (
				<Box
					sx={{
						position: "fixed",
						display: "inline-block",
						bottom: "85px", // Adjusted to be above the chart filters box
						left: "45px",
						height: "400px",
						width: "300px",
						backgroundColor: "white",
						borderRadius: "10px",
						padding: "20px",
						boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
						display: "flex",
						flexDirection: "column",
						justifyContent: "space-between",
					}}>
					<Box display={"flex"} justifyContent={"space-between"} flexDirection={"row"} alignItems={"center"}>
						<Typography variant="body1" fontWeight={"bold"}>
							{t('UI_TEXT.ADDITIONAL_FILTERS')}
						</Typography>
						<Tooltip title={t('TITLES.CLEAR_ALL_FILTERS')}>
							<IconButton onClick={() => setIsVisible(false)}>
								<CloseIcon sx={{ fontSize: "20px" }} />
							</IconButton>
						</Tooltip>
					</Box>
					<Box height={"80%"} maxHeight={"80%"} overflow={"auto"}>
						{additionalFilters.length <= 0 && (
							<>
								<Box
									display={"flex"}
									height={"100%"}
									width={"100%"}
									justifyContent={"flex-start"}
									alignItems={"center"}
									flexDirection={"column"}>
									<FilterListIcon sx={{ fontSize: "40px", color: "#ddd" }} />
									<Typography variant="body1" fontWeight={"bold"} textAlign={"center"} color={"#ddd"}>
										{t('UI_TEXT.NO_ADDITIONAL_FILTERS')}
									</Typography>
								</Box>
							</>
						)}
						{additionalFilters.map((filter) => (
							<Box key={filter.id} my={2}>
								<Typography key={filter.id} fontSize={"12px"} marginBottom={0}>
									{filter.chartName}
								</Typography>
								<Divider sx={{ marginTop: "2px", mb: 1 }} />
								<Box
									sx={{
										backgroundColor: "#eee",
										width: "fit-content",
										padding: "5px 10px",
										display: "flex",
										flexDirection: "row",
										alignItems: "center",
										justifyContent: "space-between",
										borderRadius: "5px",
									}}>
									<Typography key={filter.id} fontSize={"11px"}>
										{filter.id} - <b>{filter.name}</b>
									</Typography>
									<IconButton
										sx={{
											padding: "0px 2px",
											marginLeft: "5px",
										}}
										onClick={() =>
											setAdditionalFilters(additionalFilters.filter((f) => f.id !== filter.id))
										}>
										<CloseIcon sx={{ fontSize: "12px" }} />
									</IconButton>
								</Box>
							</Box>
						))}
					</Box>
					{additionalFilters.length > 0 && (
						<Box display={"flex"} justifyContent={"center"}>
							<Button
								variant="text"
								color="primary"
								onClick={() => {
									setAdditionalFilters([]);
									setIsVisible(false);
								}}>
								<FilterAltOffIcon /> {t('UI_TEXT.CLEAR_ALL_FILTERS')}
							</Button>
						</Box>
					)}
				</Box>
			)}
			<Tooltip title={t('TITLES.GLOBAL_CHART_FILTERS')}>
				<Box sx={{ position: "fixed", display: "inline-block", bottom: "30px", left: "30px" }} data-tour="manage-chart-filters">
					<Badge
						badgeContent={additionalFilters.length}
						sx={{
							"& .MuiBadge-badge": {
								backgroundColor: "#fff",
								color: "primary.main",
								position: "absolute",
								top: "5px",
								right: "5px",
								transform: "translate(50%, -50%)",
								zIndex: 1000,
								borderColor: "primary.main",
								border: "1px solid",
							},
						}}>
						<Box className={`filter-box show`} onClick={filterBox}>
							<FilterAltIcon fontSize="large" />
						</Box>
					</Badge>
				</Box>
			</Tooltip>
		</>
	);
};

export default FilterBox;
